var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0L12 2.35714V3.14286H11.2C11.2 3.24926 11.1573 3.34133 11.0719 3.41908C10.9865 3.49684 10.8854 3.53571 10.7688 3.53571H1.23125C1.11458 3.53571 1.01354 3.49684 0.928125 3.41908C0.842708 3.34133 0.8 3.24926 0.8 3.14286H0V2.35714L6 0ZM1.6 3.92857H3.2V8.64286H4V3.92857H5.6V8.64286H6.4V3.92857H8V8.64286H8.8V3.92857H10.4V8.64286H10.7688C10.8854 8.64286 10.9865 8.68173 11.0719 8.75949C11.1573 8.83724 11.2 8.92932 11.2 9.03571V9.42857H0.8V9.03571C0.8 8.92932 0.842708 8.83724 0.928125 8.75949C1.01354 8.68173 1.11458 8.64286 1.23125 8.64286H1.6V3.92857ZM11.5688 9.82143C11.6854 9.82143 11.7865 9.8603 11.8719 9.93806C11.9573 10.0158 12 10.1079 12 10.2143V11H0V10.2143C0 10.1079 0.0427083 10.0158 0.128125 9.93806C0.213542 9.8603 0.314583 9.82143 0.43125 9.82143H11.5688Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsIcon);
export default __webpack_public_path__ + "static/media/insIcon.f6c53ba6ae507cee71e43a3a92b5de27.svg";
export { ForwardRef as ReactComponent };